import { motion } from "framer-motion";
import { ArrowRight, Handshake } from "lucide-react";
import { CIEDA_PHONE_TEL } from "@/lib/constants";

const CTASection = () => (
  <section className="relative py-16 md:py-24 overflow-hidden" style={{ background: "var(--hero-gradient)" }}>
    {/* Pattern */}
    <div className="absolute inset-0 opacity-[0.03]" style={{ backgroundImage: "radial-gradient(circle at 1px 1px, white 1px, transparent 0)", backgroundSize: "32px 32px" }} />

    {/* Glow */}
    <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[400px] bg-secondary/10 rounded-full blur-[120px]" />

    <div className="container-max relative z-10 text-center px-5">
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.7 }}
      >
        <div className="inline-flex items-center justify-center w-16 h-16 rounded-2xl bg-secondary/15 border border-secondary/25 mb-8">
          <Handshake className="text-secondary" size={28} />
        </div>

        <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-primary-foreground leading-tight mb-6 max-w-3xl mx-auto text-balance">
          Devenez partenaire de la distribution{" "}
          <span className="text-gradient-gold">qui fait la différence</span>
        </h2>

        <p className="text-primary-foreground/50 text-lg max-w-xl mx-auto mb-10 font-light">
          Rejoignez notre réseau de détaillants et grossistes. Bénéficiez de prix compétitifs, de livraisons fiables et d'un support dédié.
        </p>

        <div className="flex flex-wrap justify-center gap-4">
          <a
            href="#catalog"
            className="inline-flex items-center gap-2.5 px-8 py-4 rounded-full bg-secondary text-secondary-foreground font-semibold text-base hover:bg-gold-light transition-all duration-300 shadow-lg shadow-secondary/25 shine"
          >
            Commander Maintenant
            <ArrowRight size={18} />
          </a>
          <a
            href={CIEDA_PHONE_TEL}
            className="inline-flex items-center gap-2 px-8 py-4 rounded-full border border-primary-foreground/20 text-primary-foreground font-medium text-base hover:bg-primary-foreground/10 transition-all duration-300"
          >
            Nous Appeler
          </a>
        </div>
      </motion.div>
    </div>
  </section>
);

export default CTASection;
